import React, { useState, useEffect, useCallback, useContext } from 'react'
import styles from './FilesContainer.module.css'
import * as fileReq from '../../../axios/requests/filesReq'
import SingleManagerFile from './SingleManagerFile'
import FilePreview from './FilePreview'
import * as settings from '../../../settings'
import { useTranslation } from "react-i18next";
import AlertContext from '../../../context/AlertModelContext/AlertModalContext';
// import Spinner from '../../UI/Spinner/Spinner'
import { Spinner } from 'react-bootstrap';
import { getListOfSignatures } from '../../../axios/requests/signatureReq';
import SignatureDetails from './SignatureDetails';
// const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV
const perPageCounter = settings.FILE_MANAGER_PER_PAGE_ITEMS || 10
const maxLoadItems = settings.FILE_MANAGER_MAX_LOAD_FILES || 36
const delayToLoadNewPage = settings.FILE_DELAY_LOAD_PAGE_MS || 1000
const maxSelectItemCount = settings.FILE_MAX_SELECT_FILES_COUNT || 10

const FilesContainer = ({ fileCategory, onSelectFile, tabKey, searchInput, showSpinnerManagerState, mediaTokenData, permissionType, onAttachOneFileClicked, fileTypesLimit, clientName, contactName,msgType }) => {
    const [filesArrState, setFilesArrState] = useState([])
    const [pageState, setPageState] = useState(1)
    const [selectedFilesState, setSelectedFilesState] = useState([])
    const [selectedPreviewFileState, setSelectedPreviewFileState] = useState()
    const [loadingState, setLoadingState] = useState(false)
    const alertCtx = useContext(AlertContext)
    const [showSpinnerState, setShowSpinnerState] = useState(true)
    const [showSignatureDetailsState, setShowSignatureDetailsState] = useState() // Signature object
    const [t] = useTranslation('common')

    useEffect(() => {
        loadFiles()
    }, [])

    useEffect(() => {// Dynamic document load on scroll
        const fileManagerModelElement = document.getElementById("file-manager-model")
        fileManagerModelElement.addEventListener('scroll', dynamicLoadDocsOnScroll);
        return () => fileManagerModelElement.removeEventListener('scroll', dynamicLoadDocsOnScroll);
    }, [])

    useEffect(() => {
        if (loadingState) {
            loadFiles();
        }
    }, [loadingState]);

    useEffect(() => {
        setShowSpinnerState(showSpinnerManagerState)
    }, [showSpinnerManagerState])
    const loadFiles = () => {
        if (pageState * perPageCounter > maxLoadItems) return //limit
        setTimeout(async () => {
            try {
                let files
                if (fileCategory === 'signature') {
                    files = await getListOfSignatures()
                }
                else {
                    files = await fileReq.getFiles(pageState, perPageCounter, fileCategory, true, searchInput, fileTypesLimit)
                }

                setFilesArrState(oldFilesArrState => [...oldFilesArrState, ...files])
                setPageState((oldPageState) => (oldPageState + 1))
                setLoadingState(false);
                setShowSpinnerState(false)
            } catch (e) {
                console.log(`loadFiles :: Error=${e.message}`)
                setLoadingState(false);
            }
        }, delayToLoadNewPage)
    }

    const dynamicLoadDocsOnScroll = useCallback(async () => {
        const fileManagerModelElement = document.getElementById("file-manager-model")
        const fileManagerTabsElement = document.getElementById(`file-manager-tabs-tabpane-${tabKey}`)
        if (fileManagerTabsElement.scrollHeight && (fileManagerModelElement.clientHeight + fileManagerModelElement.scrollTop >= fileManagerTabsElement.scrollHeight - 2)) {
            setLoadingState(true);
        }
    }, [])



    const onClickFileSelectionHandler = useCallback((selectedFileId) => {
        setSelectedFilesState((oldSelectedItemsState) => {
            const fileIndex = oldSelectedItemsState.findIndex((fileItem) => fileItem._id === selectedFileId)
            const newState = JSON.parse(JSON.stringify(oldSelectedItemsState))
            if (fileIndex > -1) {// unselect
                newState.splice(fileIndex, 1)
            }
            else {
                if (newState.length + 1 > maxSelectItemCount) { // to much selected files alert!
                    alertCtx.showAlert(t('fail'), t('A maximum of files must be selected', { count: maxSelectItemCount }), 'sm')
                    onSelectFile(newState)
                    return newState
                }
                const toInsertObj = filesArrState.find((fileItem) => fileItem._id === selectedFileId)
                if (toInsertObj) newState.push(toInsertObj)
            }
            onSelectFile(newState)
            return newState
        })
    }, [filesArrState])

    const onClickAttachFileHandler = useCallback((selectedFileId) => {//Todo signature
        const toAttachObj = filesArrState.find((fileItem) => fileItem._id === selectedFileId)
        if (toAttachObj) {
            if (toAttachObj.fileType === 'signature') {
                setShowSignatureDetailsState(toAttachObj)
            }
            else {
                onAttachOneFileClicked(toAttachObj)
            }
        }
    }, [filesArrState])

    const onClearAllSelectionClickHandler = useCallback(() => {
        setSelectedFilesState([])
        onSelectFile([])
        setSelectedPreviewFileState()
    }, [])

    const onPreviewClickedHandler = useCallback((selectedFileId) => {
        const toPreview = filesArrState.find((fileItem) => fileItem._id === selectedFileId)
        if (toPreview) {
            setSelectedPreviewFileState((prevPreviewFileState) => {
                if (prevPreviewFileState?._id === toPreview._id) return
                return toPreview
            })
        }
    }, [filesArrState])

    // const onPrevieHideHandler = useCallback(() => {
    //     setSelectedPreviewFileState()
    // }, [])
    const onDeleteFileHandler = useCallback((fileId) => {
        setFilesArrState((oldFilesArr) => {
            return oldFilesArr.filter(file => file._id !== fileId)
        })
    }, [])

    const onHideSignatureDetailsClicked = useCallback(() => {
        setShowSignatureDetailsState()
    }, [])

    const onSignatureDocAttachClickedHandler = useCallback((signatureDetails) => {
        onAttachOneFileClicked(signatureDetails)
    }, [])


    const fileElementsArr = filesArrState.map((fileItem) => {
        let fileUrl
        const isFileSelected = !!selectedFilesState.find((fileStateItem) => fileStateItem._id === fileItem._id)
        if (fileCategory === 'signature') {
            fileUrl = fileItem.fileUrl
        }
        else {
            fileUrl = fileReq.getFileUrl(mediaTokenData?.mediaToken, fileItem._id)
        }
        const isPreviewSelected = !!(selectedPreviewFileState && selectedPreviewFileState._id === fileItem._id)

        return <SingleManagerFile
            key={fileItem._id}
            id={fileItem._id}
            fileUrl={fileUrl}
            fileName={fileItem.fileName}
            isFileSelected={isFileSelected}
            onSelectClicked={onClickFileSelectionHandler}
            onPreviewClicked={onPreviewClickedHandler}
            fileType={fileItem.fileType}
            createdAt={fileItem.createdAt}
            isPreviewSelected={isPreviewSelected}
            onDeleteFile={fileCategory !== 'signature' && onDeleteFileHandler}
            permissionType={permissionType}
            onClickAttachFile={onClickAttachFileHandler}
            previewUrl={fileItem.previewUrl}
        />
    }
    )

    return (
        <>{showSpinnerState ?
            <div className={styles['spinner-container']}>
                <Spinner animation="border" variant="secondary" className={`${styles['spinner']}`} />
            </div>
            :
            <div className={`${styles['files-main-container']}`}>

                <section className={`${styles['files-container-section']} ${selectedPreviewFileState && styles['files-container-section--preview-selected']}`} onClick={onClearAllSelectionClickHandler}>
                    {fileElementsArr}
                </section>
                {
                    selectedPreviewFileState &&
                    <FilePreview file={selectedPreviewFileState} fileUrl={fileReq.getFileUrl(mediaTokenData?.mediaToken, selectedPreviewFileState._id)} fileCategory={fileCategory} mediaTokenData={mediaTokenData} />
                }
                {
                    showSignatureDetailsState &&
                    <SignatureDetails
                        onHide={onHideSignatureDetailsClicked}
                        onSignatureDocAttachClicked={onSignatureDocAttachClickedHandler}
                        clientName={clientName}
                        contactName={contactName}
                        msgType={msgType}
                        {...showSignatureDetailsState}
                    />
                }
            </div >
        }
        </>)
}

export default React.memo(FilesContainer)